export const WORKFLOW_URL = '/api/v1/Workflow'
